module.exports = require("./../../_gen/starling/assets/AssetType");